"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _actions = require("./actions");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context19, _context20; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context19 = ownKeys(Object(source), !0)).call(_context19, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context20 = ownKeys(Object(source))).call(_context20, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var toggleColumnVisiblity = function toggleColumnVisiblity(cols, _ref) {
  var key = _ref.key,
      status = _ref.status;
  return (0, _map["default"])(cols).call(cols, function (c) {
    var newCol = _objectSpread({}, c);

    if (newCol.key === key) {
      newCol.hidden = status;
    }

    return newCol;
  });
};

var toggleColumnFixed = function toggleColumnFixed(cols, _ref2) {
  var _context, _context2;

  var key = _ref2.key,
      direction = _ref2.direction;
  var selectionColumn = null;
  var notSelectionCols = (0, _filter["default"])(cols).call(cols, function (column) {
    if (column.key === "__selection__") {
      selectionColumn = _objectSpread({}, column);
      return false;
    }

    return true;
  });
  var reorderedColumns = (0, _map["default"])(notSelectionCols).call(notSelectionCols, function (c) {
    var newCol = _objectSpread({}, c);

    if (newCol.key === key) {
      newCol.frozen = newCol.frozen === direction ? false : direction;
    }

    return newCol;
  });
  return (0, _filter["default"])(_context = (0, _concat["default"])(_context2 = [selectionColumn]).call(_context2, (0, _toConsumableArray2["default"])(reorderedColumns))).call(_context, Boolean);
};

function reducer(state, action) {
  var _context3, _context4, _context5, _context7, _context8, _context10, _context12, _context13, _context14, _context15, _context16, _context17, _context18;

  switch (action.type) {
    case _actions.LOAD_MORE_DATA_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingMore: true
      });

    case _actions.LOAD_MORE_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _concat["default"])(_context3 = []).call(_context3, (0, _toConsumableArray2["default"])(state.data), (0, _toConsumableArray2["default"])(action.payload))
      });

    case _actions.IS_TABLE_BUSY:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: action.payload
      });

    case _actions.LOAD_MORE_DATA_STOP:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoadingMore: false
      });

    case _actions.UPDATE_STATE_VALUES:
      return _objectSpread(_objectSpread({}, state), action.payload);

    case _actions.REORDER_COLUMNS:
      return _objectSpread(_objectSpread({}, state), {}, {
        columns: action.payload
      });

    case _actions.TOGGLE_COLUMN_VISIBILITY:
      return _objectSpread(_objectSpread({}, state), {}, {
        columns: toggleColumnVisiblity(state.columns, action.payload)
      });

    case _actions.TOGGLE_COLUMN_FIXED:
      return _objectSpread(_objectSpread({}, state), {}, {
        columns: toggleColumnFixed(state.columns, action.payload)
      });

    case _actions.SET_EXPORTABLE_COLUMNS:
      return _objectSpread(_objectSpread({}, state), {}, {
        exportableColumnKeys: action.payload
      });

    case _actions.SET_COLUMNS_INITIAL_WIDTH:
      return _objectSpread(_objectSpread({}, state), {}, {
        isInitialWidthSet: true,
        tableWidth: action.payload,
        columns: (0, _utils.setColumnsInitialWidth)(state.columns, action.payload, state.isSelectable)
      });

    case _actions.TOGGLE_SELECT_ALL:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedRows: action.payload === true ? (0, _concat["default"])(_context4 = []).call(_context4, (0, _toConsumableArray2["default"])((0, _filter["default"])(_context5 = state.selectedRows).call(_context5, function (r) {
          var _context6;

          return (0, _includes["default"])(_context6 = state.disabledRows).call(_context6, r);
        })), (0, _toConsumableArray2["default"])((0, _map["default"])(_context7 = (0, _filter["default"])(_context8 = state.data).call(_context8, function (row) {
          var _context9;

          return !(0, _includes["default"])(_context9 = state.disabledRows).call(_context9, row[state.uniqueDataKey]);
        })).call(_context7, function (item) {
          return item[state.uniqueDataKey];
        }))) : (0, _filter["default"])(_context10 = state.selectedRows).call(_context10, function (r) {
          var _context11;

          return (0, _includes["default"])(_context11 = state.disabledRows).call(_context11, r);
        }),
        allRowsSelected: action.payload
      });

    case _actions.TOGGLE_ROW_SELECTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedRows: (0, _includes["default"])(_context12 = state.selectedRows).call(_context12, action.payload) ? (0, _filter["default"])(_context13 = state.selectedRows).call(_context13, function (el) {
          return el !== action.payload;
        }) : (0, _concat["default"])(_context14 = []).call(_context14, (0, _toConsumableArray2["default"])(state.selectedRows), [action.payload])
      });

    case _actions.SET_SELECTED_ROWS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedRows: action.payload
      });

    case _actions.TOGGLE_ROW_EXPANSION:
      return _objectSpread(_objectSpread({}, state), {}, {
        expandedRows: (0, _includes["default"])(_context15 = state.expandedRows).call(_context15, action.payload) ? (0, _filter["default"])(_context16 = state.expandedRows).call(_context16, function (el) {
          return el !== action.payload;
        }) : (0, _concat["default"])(_context17 = []).call(_context17, (0, _toConsumableArray2["default"])(state.expandedRows), [action.payload])
      });

    case _actions.SELECT_SINGLE_ROW:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedRow: action.payload
      });

    case _actions.ALL_ROWS_SELECTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        allRowsSelected: action.payload
      });

    case _actions.COLUMN_RESIZE_END:
      return _objectSpread(_objectSpread({}, state), {}, {
        columns: (0, _map["default"])(_context18 = state.columns).call(_context18, function (column) {
          var newWidth = column.key === action.payload.column.key ? action.payload.width : column.width;
          return _objectSpread(_objectSpread({}, column), {}, {
            width: newWidth
          });
        })
      });

    default:
      throw new Error("Unhandled action type: ".concat(action.type));
  }
}

var _default = reducer;
exports["default"] = _default;